import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createCompaniesRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      component: () => import('../layouts/route-layout.vue'),
      children: [
        {
          path: '',
          component: () => import('../views/companies-view.vue'),
          name: routeDefinitions.administration.companies
        }
      ]
    }
  ]
}
